import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M9.001 12a3 3 0 1 0 6 0 3 3 0 1 0-6 0m3-10.5v2.25m0 16.5v2.25m10.5-10.5h-2.25m-16.5 0h-2.25m17.924-7.424-1.591 1.591M6.167 17.834l-1.591 1.591m14.849 0-1.591-1.591M6.167 6.167 4.576 4.576"
    }, null, -1)
  ]));
}
const interfaceLightingBrightness = { render };
export {
  interfaceLightingBrightness as default,
  render
};
//# sourceMappingURL=interface-lighting-brightness.svg.js.map
